export default {
	"permission": {
		"role": "บทบาท",
		"addRole": "เพิ่มบทบาท",
		"roleName": "ชื่อบทบาท",
		"roleNameTips": "กรุณากรอกชื่อบทบาท"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/permission/permission.js